import { useTheme } from '@mui/material';

export const useDateCellStyles = () => {
  const theme = useTheme();

  return {
    dataCell: {
      verticalAlign: 'top !important',
    },
    text: {
      paddingTop: theme.spacing(1.25),
    },
  };
};
